import * as _ from 'lodash';
import {
    DefaultPortModel,
} from "@projectstorm/react-diagrams";

export class CustomPortModel extends DefaultPortModel {

    debugInfo;

    constructor(props) {
        super(props);
        this.connection = props.connection;
    }

    serialize() {
        return _.merge(super.serialize(), {
            connection: this.connection
        })
    }

    deSerialize(data, engine) {
        super.deSerialize(data, engine);
        this.connection = data.connection;
    }
}